module.exports = __webpack_public_path__ + "img/help-section-image01.ce2b60c3.png";